import { Box } from "@mui/material"
import { SectorWorkflowOrchestrator } from "../components/orchestrator/SectorWorkflowOrchestrator"

export const SectorWorkFlowView = () => {
    return (
        <Box sx={{ width: "100%" }}>
            <SectorWorkflowOrchestrator />
        </Box>
    )
}